import React, { PropTypes } from 'react'
import * as loader from 'loader'
import { components } from 'unity-core'
const { Loader } = components

export class AppLoader extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loaded: false,
            progress: {}
        }
    }
    componentDidMount() {
        loader.loadAllBundles((x) => {
            this.setState({ progress: x.progress })
        }, () => {
            this.setState({ loaded: true })
        })
    }
    render() {
        const { r } = this.props
        const { loaded, progress } = this.state
        if (!loaded)
            return <div style={{ textAlign: 'center' }}><Loader />Loading modules ({progress.pos}/{progress.total})</div>
        return r()
    }
}

AppLoader.propTypes = {
    r: PropTypes.func.isRequired
}

export default AppLoader